export const syncStructuredBindingForSave = (element) => {
    if (!element || !element.properties) {
        return element;
    }

    const props = element.properties || {};
    if (props.binding) {
        return {
            ...element,
            binding: props.binding
        };
    }

    if (element.binding) {
        return {
            ...element,
            properties: {
                ...props,
                binding: element.binding
            }
        };
    }

    return element;
};

export const syncTableBindingForSave = (element) => {
    const synced = syncStructuredBindingForSave(element);
    if (!synced || synced.type !== 'Table' || !synced.properties) {
        return synced;
    }

    const props = synced.properties;
    return {
        ...synced,
        Bound: props.Bound !== undefined ? props.Bound : (synced.Bound || false),
        DataSource: props.DataSource !== undefined ? props.DataSource : (synced.DataSource || ''),
        IsDynamic: props.IsDynamic !== undefined ? props.IsDynamic : (synced.IsDynamic || false),
        ColumnMapping: props.ColumnMapping !== undefined ? props.ColumnMapping : (synced.ColumnMapping || []),
        binding: props.binding !== undefined ? props.binding : synced.binding
    };
};


export const inspectStructuredTableBindings = (objects) => {
    const tables = Object.keys(objects || {})
        .map(key => ({key, element: objects[key]}))
        .filter(({element}) => element && element.type === 'Table')
        .map(({key, element}) => {
            const rootBinding = element.binding;
            const propertiesBinding = element.properties && element.properties.binding;
            const binding = rootBinding || propertiesBinding || null;
            return {
                key,
                kind: binding && binding.kind ? String(binding.kind).toLowerCase() : '',
                rowsPath: binding && binding.rowsPath ? binding.rowsPath : '',
                atRoot: !!rootBinding,
                atProperties: !!propertiesBinding
            };
        });

    return {
        tableElementCount: tables.length,
        boundTableCount: tables.filter(table => table.kind === 'table').length,
        tables
    };
};
